import { Sale } from 'src/WebApiController';

export const useShouldHideForWastedSale = (sale: Sale | null | undefined) => {
  return !!sale?.isWastageSale;
};
